import { SUBCLUSTERS } from '../subclusters.js';

const FINANCE_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.ACCOUNTING,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.BUDGET_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.FORECAST_PLANNING_ANALYTICS,
        },
        {
            key: SUBCLUSTERS.BILLING_INVOICING,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.BUSINESS_OPERATIONS,
        },
        {
            key: SUBCLUSTERS.CLIENT_PROJECTS,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
    ],
};

export { FINANCE_CLUSTER };
